import useConfigStore from '@/stores/useConfigStore';
import styled from '@emotion/native';
import React, { useRef } from 'react';

const DevMenuButton = () => {
  const { setIsDevMenuOpen } = useConfigStore();

  const lastTapTime = useRef(0);
  const tapCount = useRef(1);

  // Show the dev menu on hidden box triple tap
  const onPressDevMenuButton = () => {
    const currentTime = Date.now();
    const timeDifference = currentTime - lastTapTime.current;

    if (timeDifference < 500) {
      tapCount.current += 1;
    } else {
      tapCount.current = 1;
    }

    if (tapCount.current === 3) {
      setIsDevMenuOpen(true);
    }

    lastTapTime.current = currentTime;
  };

  return <TouchableContainer onPress={onPressDevMenuButton} />;
};

export default DevMenuButton;

const TouchableContainer = styled.Pressable({
  position: 'absolute',
  top: 64,
  right: 8,
  width: 72,
  height: 72,
  zIndex: 100,
});
